export const createKey = (input: string) => {
	return input ? input.replace(/^(the|a|an)/, '').replace(/\s/g, '') : input;
};

export const parseStringBoolUndefined = (newValue?: string | boolean): boolean => {
	switch (typeof newValue) {
		case 'string':
			switch (newValue.toLowerCase()) {
				case 'true':
					return true;
				case 'false':
					return false;
				default:
					throw new Error('The value could not be interpreted as a boolean');
			}
		case 'boolean':
			return newValue;
		case 'undefined':
			return false;
		default:
			throw new Error('The value could not be interpreted as a boolean');
	}
};
